<template>
  <div>
    <!-- <v-app-bar
      app
      color="appMenu"
      dense
      class="fill-height"
      dark
      clipped-right
      height="32"
      fixed
    >
      <v-icon left>mdi-file-document-multiple</v-icon>{{ $t("menu.documents") }}
      <v-spacer></v-spacer>
    </v-app-bar> -->
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12">
          <document-settings></document-settings>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style scoped>
::v-deep .container--fluid {
  padding: 0px !important;
}
</style>
<script>
// @ is an alias to /src
import DocumentSettings from "../components/documents/DocumentSettings.vue";
import { SplitterPlugin } from "@syncfusion/ej2-vue-layouts";
import Vue from "vue";
Vue.use(SplitterPlugin);
export default {
  name: "Documents",
  components: {
    DocumentSettings,
  },
};
</script>
